import * as _ from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';

import Dialog from 'kpc/components/dialog';
import { Table, TableColumn } from 'kpc/components/table';
import Icon from 'kpc/components/icon';
import { Form, FormItem } from 'kpc/components/form';
import { Button, ButtonGroup } from 'kpc/components/button';
import Input from 'kpc/components/input';
import Spin from 'kpc/components/spin';
import { Tabs, Tab } from 'kpc/components/tabs';
import Tooltip from 'kpc/components/tooltip';
import Message from 'kpc/components/message';
import whiteList from "../../../service/common/whiteList";

import vpcData from "../../../service/vpc/vpcData";
import TableWithPagination from "../../../components/TableWithPagination/index.vue";
import getChargeTypeChina from '../../../service/common/getChargeTypeChina';
import apiRequest from '../../../service/vpc/request';
import trustApiRequest from '../../../service/trust_vpc/request';

@Component({
    components: {
        Dialog,
        Table, TableColumn,
        Icon,
        Form, FormItem,
        Button, ButtonGroup,
        Input,
        TableWithPagination,
        Spin,
        Tabs, Tab,
        Tooltip
    }
})
export default class RuleBatchRemoveDialog extends Vue {
    show = false;
    cb?: () => void;
    region = '';
    type = '';
    groupId = '';
    isOutRuleIP0: boolean = false;
    onOffNum = 0;
    vpcData: any = vpcData;
    getChargeTypeChina = getChargeTypeChina;
    list: any[] = [];

    get disabledOk() {
        return this.list.length === 0;
    }

    get regionSupportDeny() {
        let me: any = this;
        return whiteList.check("sgSupportDeny", me.region);
    }

    // 区分开互信vpc和普通vpc的接口
    get request() {
        return this.$route.path.indexOf('trust-vpc') !== -1 ? trustApiRequest : apiRequest
    }

    onClose() {
        let me: any = this;
        me.isOutRuleIP0 = false;
        me.onOffNum = 0;
    }

    deleteRule(val: any) {
        let me: any = this;

        let dialog: any = me.$refs.dialog;
        dialog.showLoading();

        if (me.type == 'out' && me.onOffNum == 0) {
            _.forEach(me.list, function (item) {
                if (item.Protocol.toUpperCase() == "IP" && item.CidrBlock == "0.0.0.0/0") {
                    me.onOffNum = 1;
                }
            });
        }

        if (me.onOffNum == 1) {
            me.onOffNum = 888; //只需要阻止一次即可
            me.isOutRuleIP0 = true;
            dialog.hideLoading();
        } else {
            me.isOutRuleIP0 = false;
            let listOfChecked = _.map(me.list, 'SecurityGroupEntryId');
            let _sendData = listOfChecked.join(',');
            // apiRequest.DeleteSecurityGroupEntrys({
            this.request.DeleteSecurityGroupEntrys({
                Region: me.region,
                groupId: me.groupId,
                ids: _sendData
            }).done((data: any) => {
                if (data && data.Return) {
                    Message.success(me.$trans(`删除成功`));
                }
                me.show = false;
                me.cb && me.cb();
            }).always(() => {
                this.show = false;
                dialog.hideLoading();
            });
        }
    }

    public open(region: string, type: string, list: any[], cb: any) {
        this.region = region;
        this.cb = cb;
        this.type = type;
        this.list = list;
        this.show = true;
        this.groupId = this.$route.params.groupId;
    }

};

